function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { createSlice } from '@reduxjs/toolkit';
import { positionTemplatePropertyFactory } from '../../resources/report.resource';
var initialState = {
    reports: [],
    templates: [],
    summaryTemplateProperties: [],
    accountBalanceTemplateProperties: []
};
export var ReportReducer = createSlice({
    name: 'report',
    initialState: initialState,
    reducers: {
        setAllReports: function setAllReports(state, reports) {
            state.reports = reports.payload;
        },
        addReport: function addReport(state, report) {
            state.reports.push(report.payload);
        },
        deleteReport: function deleteReport(state, deleteReportId) {
            var deletedIds = deleteReportId.payload.ids;
            state.reports = state.reports.filter(function (item) {
                return !deletedIds.includes(item.id);
            });
        },
        deleteTemplate: function deleteTemplate(state, payloadAction) {
            state.templates = state.templates.filter(function (item) {
                return item.id !== payloadAction.payload;
            });
        },
        updateReport: function updateReport(state, report) {
            var index = state.reports.findIndex(function (item) {
                return item.id === report.payload.id;
            });
            state.reports[index] = report.payload;
        },
        setReportTemplates: function setReportTemplates(state, payloadAction) {
            state.templates = payloadAction.payload;
        },
        getReportsInProgress: function getReportsInProgress(state, payloadAction) {
            state.reports = state.reports.map(function (item) {
                var updatedReport = payloadAction.payload.find(function (unit) {
                    return unit.id === item.id;
                });
                return updatedReport ? updatedReport : item;
            });
        },
        setSummaryTemplateProperties: function setSummaryTemplateProperties(state, payloadAction) {
            state.summaryTemplateProperties = payloadAction.payload;
        },
        setAccountBalanceTemplateProperties: function setAccountBalanceTemplateProperties(state, payloadAction) {
            state.accountBalanceTemplateProperties = positionTemplatePropertyFactory(payloadAction.payload);
        },
        updateTemplateProperties: function updateTemplateProperties(state, payloadAction) {
            var property = payloadAction.payload;
            state.summaryTemplateProperties = state.summaryTemplateProperties.map(function (item) {
                return property.property === item.property ? property : item;
            });
        },
        updateAccountBalanceTemplateProperties: function updateAccountBalanceTemplateProperties(state, payloadAction) {
            var property = payloadAction.payload;
            state.accountBalanceTemplateProperties = state.accountBalanceTemplateProperties.map(function (item) {
                return property.property === item.property ? _objectSpread(_objectSpread({}, item), {}, {
                    value: property.value
                }) : item;
            });
        }
    }
});
var _ReportReducer$action = ReportReducer.actions, addReport = _ReportReducer$action.addReport, setAllReports = _ReportReducer$action.setAllReports, deleteReport = _ReportReducer$action.deleteReport, updateReport = _ReportReducer$action.updateReport, setReportTemplates = _ReportReducer$action.setReportTemplates, deleteTemplate = _ReportReducer$action.deleteTemplate, getReportsInProgress = _ReportReducer$action.getReportsInProgress, setSummaryTemplateProperties = _ReportReducer$action.setSummaryTemplateProperties, updateTemplateProperties = _ReportReducer$action.updateTemplateProperties, setAccountBalanceTemplateProperties = _ReportReducer$action.setAccountBalanceTemplateProperties, updateAccountBalanceTemplateProperties = _ReportReducer$action.updateAccountBalanceTemplateProperties;
export { addReport, setAllReports, deleteReport, updateReport, setReportTemplates, deleteTemplate, getReportsInProgress, setSummaryTemplateProperties, updateTemplateProperties, setAccountBalanceTemplateProperties, updateAccountBalanceTemplateProperties };
export default ReportReducer.reducer;
